import React, { useState, useEffect } from 'react';

const ProcessingScreen: React.FC<{ isMobile: boolean; onComplete: () => void }> = ({ isMobile, onComplete }) => {
  const [processingStep, setProcessingStep] = useState(0);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successStep, setSuccessStep] = useState(1);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [showFinalSuccess, setShowFinalSuccess] = useState(false);
  
  const messages = [
    'Scanning available government incentives',
    'Analysing postcode, income & age',
    'Determining Eligibility'
  ];
  
  React.useEffect(() => {
    if (showSuccess) return;
    
    const interval = setInterval(() => {
      setProcessingStep(prev => {
        if (prev < messages.length - 1) {
          return prev + 1;
        } else {
          clearInterval(interval);
          setTimeout(() => {
            setShowSuccess(true);
          }, 1000);
          return prev;
        }
      });
    }, 2000);
    
    return () => clearInterval(interval);
  }, [messages.length, showSuccess]);
  
  // Show final success screen after form submission
  if (showFinalSuccess) {
    return (
      <div style={{
        textAlign: 'center',
        padding: '40px 20px',
        minHeight: '400px',
        maxWidth: '600px',
        margin: '0 auto'
      }}>
        {/* 100% Complete Progress Bar */}
        <div style={{ marginBottom: '30px' }}>
          <div style={{
            textAlign: 'center',
            marginBottom: '10px',
            fontSize: '16px',
            color: '#00a651',
            fontWeight: 'bold'
          }}>
            Complete - 100%
          </div>
          <div style={{
            width: '100%',
            height: '8px',
            backgroundColor: '#e2e8f0',
            borderRadius: '4px',
            overflow: 'hidden'
          }}>
            <div style={{
              width: '100%',
              height: '100%',
              backgroundColor: '#00a651',
              transition: 'width 1s ease-in-out',
              backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,.2) 10px, rgba(255,255,255,.2) 20px)'
            }}></div>
          </div>
        </div>
        <div style={{
          fontSize: '60px',
          color: '#00a651',
          marginBottom: '20px'
        }}>
          🎉
        </div>
        <h2 style={{
          fontSize: isMobile ? '36px' : '48px',
          fontWeight: 'bold',
          color: '#00a651',
          marginBottom: '20px'
        }}>
          Congratulations!
        </h2>
        <p style={{
          fontSize: isMobile ? '20px' : '24px',
          color: '#333',
          marginBottom: '30px',
          lineHeight: '1.5',
          fontWeight: 'bold'
        }}>
          Your Free Property Report Has Been Generated!
        </p>
        <p style={{
          fontSize: isMobile ? '18px' : '20px',
          color: '#666',
          marginBottom: '30px',
          lineHeight: '1.5'
        }}>
          One of our property investment specialists will be in contact with you shortly to discuss:
        </p>
        <div style={{
          textAlign: 'left',
          maxWidth: '400px',
          margin: '0 auto 30px',
          fontSize: isMobile ? '16px' : '18px',
          color: '#333'
        }}>
          <div style={{ marginBottom: '15px', display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#00a651', marginRight: '10px', fontSize: '20px' }}>✓</span>
            <span>Your personalised hotspot property report</span>
          </div>
          <div style={{ marginBottom: '15px', display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#00a651', marginRight: '10px', fontSize: '20px' }}>✓</span>
            <span>Government incentives you qualify for</span>
          </div>
          <div style={{ marginBottom: '15px', display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#00a651', marginRight: '10px', fontSize: '20px' }}>✓</span>
            <span>Tax strategies to redirect into your property</span>
          </div>
          <div style={{ marginBottom: '15px', display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#00a651', marginRight: '10px', fontSize: '20px' }}>✓</span>
            <span>Your pathway to property ownership in 2025</span>
          </div>
        </div>
        <div style={{
          padding: '20px',
          backgroundColor: '#f0f8ff',
          borderRadius: '10px',
          marginBottom: '30px'
        }}>
          <p style={{
            fontSize: isMobile ? '16px' : '18px',
            color: '#333',
            margin: 0,
            fontWeight: '600'
          }}>
            📞 Expect a call within 24 hours
          </p>
          <p style={{
            fontSize: isMobile ? '14px' : '16px',
            color: '#666',
            marginTop: '10px'
          }}>
            Please ensure you answer calls from (07) numbers
          </p>
        </div>
        <button
          onClick={() => {
            setShowFinalSuccess(false);
            onComplete();
          }}
          style={{
            padding: '18px 40px',
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#fff',
            backgroundColor: '#007AFF',
            border: 'none',
            borderRadius: '12px',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}
        >
          Close
        </button>
      </div>
    );
  }
  
  if (showSuccess) {
    return (
      <div style={{
        textAlign: 'center',
        padding: '40px 20px',
        minHeight: '400px',
        maxWidth: '600px',
        margin: '0 auto'
      }}>
        <h2 style={{
          fontSize: isMobile ? '32px' : '42px',
          fontWeight: 'bold',
          color: '#00a651',
          marginBottom: '20px'
        }}>
          Success!
        </h2>
        <p style={{
          fontSize: isMobile ? '18px' : '22px',
          color: '#333',
          marginBottom: '40px',
          lineHeight: '1.5'
        }}>
          We've mapped out a strategy that works for you.<br/>
          Please confirm your details.
        </p>
        
        <div style={{
          textAlign: 'left',
          marginBottom: '30px'
        }}>
          {successStep === 1 ? (
            <>
              <input
                type="text"
                placeholder="Your first name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                style={{
                  width: '100%',
                  padding: '15px',
                  fontSize: '16px',
                  marginBottom: '15px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '12px',
                  boxSizing: 'border-box',
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  backdropFilter: 'blur(10px)',
                  transition: 'all 0.3s ease'
                }}
              />
              <input
                type="text"
                placeholder="Your last name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                style={{
                  width: '100%',
                  padding: '15px',
                  fontSize: '16px',
                  marginBottom: '20px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '12px',
                  boxSizing: 'border-box',
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  backdropFilter: 'blur(10px)',
                  transition: 'all 0.3s ease'
                }}
              />
            </>
          ) : (
            <>
              <input
                type="email"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{
                  width: '100%',
                  padding: '15px',
                  fontSize: '16px',
                  marginBottom: '15px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '12px',
                  boxSizing: 'border-box',
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  backdropFilter: 'blur(10px)',
                  transition: 'all 0.3s ease'
                }}
              />
              <input
                type="tel"
                placeholder="Your phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                style={{
                  width: '100%',
                  padding: '15px',
                  fontSize: '16px',
                  marginBottom: '20px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '12px',
                  boxSizing: 'border-box',
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  backdropFilter: 'blur(10px)',
                  transition: 'all 0.3s ease'
                }}
              />
            </>
          )}
        </div>
        
        <button
          onClick={async () => {
            if (successStep === 1) {
              // Move to step 2 if on step 1
              setSuccessStep(2);
            } else {
              // Submit on step 2
              // Save to localStorage
              localStorage.setItem('fname', firstName);
              localStorage.setItem('lname', lastName);
              localStorage.setItem('email', email);
              localStorage.setItem('phone', phone);
              
              // Get all form data from localStorage
              const formData = {
                firstName,
                lastName,
                email,
                phone,
                livingSituation: localStorage.getItem('livingSituation') || '',
                postcodeOptions: localStorage.getItem('postcodeOptions') || '',
                householdIncome: localStorage.getItem('householdIncome') || '',
                superBalance: localStorage.getItem('superBalance') || '',
                yourAge: localStorage.getItem('yourAge') || '',
                bestDescribes: localStorage.getItem('bestDescribes') || '',
                ownedYourHome: localStorage.getItem('ownedYourHome') || ''
              };
              
              console.log('=== PIPEDRIVE INTEGRATION START ===');
              console.log('📋 Form Data collected:', formData);
              
              // Create lead in Pipedrive
              try {
                const apiKey = 'e1539707d66c411b95cee99d607203941c792331';
                const leadTitle = `${firstName} ${lastName} - Easy Property Investor Lead`;
                
                // Store note content for later use
                const noteContent = `
                  Website: Easy Property Investor
                  Living Situation: ${formData.livingSituation}
                  Postcode: ${formData.postcodeOptions}
                  Household Income: ${formData.householdIncome}
                  Super Balance: ${formData.superBalance}
                  Age: ${formData.yourAge}
                  Main Goal: ${formData.bestDescribes}
                  Owned Home 3+ Years: ${formData.ownedYourHome}
                  Email: ${email}
                  Phone: ${phone}
                `;
                
                // EasyPropertyInvestor label ID from Pipedrive (green label)
                const easyPropertyInvestorLabelId = '339f5a30-8a30-11f0-920b-b393b3b852e1';
                
                // STEP 1: Create a person
                const personData = {
                  name: `${firstName} ${lastName}`,
                  email: [
                    {
                      value: email,
                      primary: true,
                      label: 'work'
                    }
                  ],
                  phone: [
                    {
                      value: phone,
                      primary: true,
                      label: 'mobile'
                    }
                  ],
                  visible_to: '3' // Everyone can see
                };
                
                const personResponse = await fetch('https://oneproperty.pipedrive.com/api/v1/persons?api_token=' + apiKey, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },
                  body: JSON.stringify(personData)
                });
                
                const personResult = await personResponse.json();
                
                if (personResult.success) {
                  // STEP 2: Now create the lead with the person_id and label
                  const leadData = {
                    title: leadTitle,
                    person_id: personResult.data.id, // Link to the person we just created
                    label_ids: easyPropertyInvestorLabelId ? [easyPropertyInvestorLabelId] : [],
                    expected_close_date: null,
                    value: {
                      amount: 0,
                      currency: 'AUD'
                    }
                  };
                  
                  const leadResponse = await fetch('https://oneproperty.pipedrive.com/api/v1/leads?api_token=' + apiKey, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'Accept': 'application/json'
                    },
                    body: JSON.stringify(leadData)
                  });
                  
                  const leadResult = await leadResponse.json();
                  
                  if (leadResult.success) {
                    // STEP 3: Add a note to the lead
                    const noteData = {
                      content: noteContent,
                      lead_id: leadResult.data?.id
                    };
                    
                    const noteResponse = await fetch('https://oneproperty.pipedrive.com/api/v1/notes?api_token=' + apiKey, {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                      },
                      body: JSON.stringify(noteData)
                    });
                    
                    const noteResult = await noteResponse.json();
                    console.log('Note creation result:', noteResult.success ? 'Success' : 'Failed');
                  }
                }
                
                setShowFinalSuccess(true);
              } catch (error: any) {
                console.error('Exception occurred:', error);
                setShowFinalSuccess(true); // Still show success to user
              }
            }
          }}
          style={{
            width: '100%',
            padding: '18px',
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#fff',
            backgroundColor: '#007AFF',
            border: 'none',
            borderRadius: '12px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            background: 'linear-gradient(135deg, #007AFF 0%, #0051D5 100%)'
          }}
        >
          {successStep === 1 ? 'Next' : 'Submit'}
        </button>
      </div>
    );
  }
  
  return (
    <>
      <div style={{
        textAlign: 'center',
        padding: '40px 20px',
        minHeight: '400px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <h2 style={{
          fontSize: isMobile ? '28px' : '36px',
          fontWeight: 'bold',
          color: '#333',
          marginBottom: '10px'
        }}>
          Processing...Hold Tight
        </h2>
        
        {/* Spinning loader */}
        <div style={{
          width: '80px',
          height: '80px',
          border: '4px solid #e2e8f0',
          borderTop: '4px solid #007AFF',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '30px auto'
        }}></div>
        
        {/* Processing messages */}
        <div style={{
          marginTop: '30px',
          minHeight: '100px'
        }}>
          {messages.map((message, index) => (
            <div 
              key={index}
              style={{
                fontSize: isMobile ? '18px' : '20px',
                color: index <= processingStep ? '#00a651' : '#999',
                margin: '15px 0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                opacity: index <= processingStep ? 1 : 0.3,
                transform: index <= processingStep ? 'scale(1)' : 'scale(0.95)',
                transition: 'all 0.5s ease'
              }}
            >
              {index <= processingStep ? (
                <span style={{
                  display: 'inline-block',
                  width: '24px',
                  height: '24px',
                  backgroundColor: '#00a651',
                  borderRadius: '50%',
                  position: 'relative'
                }}>
                  <span style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    color: 'white',
                    fontSize: '14px',
                    fontWeight: 'bold'
                  }}>✓</span>
                </span>
              ) : (
                <span style={{
                  display: 'inline-block',
                  width: '24px',
                  height: '24px',
                  border: '2px solid #999',
                  borderRadius: '50%',
                  animation: index === processingStep + 1 ? 'pulse 1.5s infinite' : 'none'
                }}></span>
              )}
              {message}
            </div>
          ))}
        </div>
        
        {/* Progress dots */}
        <div style={{
          display: 'flex',
          gap: '8px',
          marginTop: '40px'
        }}>
          {[0, 1, 2].map(dot => (
            <div
              key={dot}
              style={{
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                backgroundColor: dot <= processingStep ? '#007AFF' : '#e2e8f0',
                transition: 'background-color 0.3s ease',
                animation: dot === processingStep ? 'bounce 0.6s infinite' : 'none'
              }}
            ></div>
          ))}
        </div>
      </div>
      
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.1);
            opacity: 0.7;
          }
        }
        
        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-5px);
          }
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateX(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes float {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        
        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(300%);
          }
        }
      `}</style>
    </>
  );
};

const EasyPropertyInvestorVariation1: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [formStep, setFormStep] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [scrolled, setScrolled] = useState(false);
  const [formData, setFormData] = useState({
    livingSituation: '',
    postcodeOptions: '',
    householdIncome: '',
    superBalance: '',
    yourAge: '',
    bestDescribes: '',
    firstName: '',
    email: '',
    phone: ''
  });

  // Handle resize for responsive
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Handle scroll for header effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Update URL when step changes
  useEffect(() => {
    const stepNames = ['step-one', 'step-two', 'step-three', 'step-four', 'step-five', 'step-six', 'step-seven'];
    if (formStep > 0 && formStep <= stepNames.length) {
      window.history.replaceState({}, '', `/variation1/${stepNames[formStep - 1]}`);
    } else if (formStep === 0) {
      window.history.replaceState({}, '', '/variation1');
    }
  }, [formStep]);

  return (
    <div style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Arial, sans-serif',
      color: '#1d1d1f',
      lineHeight: '1.47059',
      fontSize: '17px',
      fontWeight: 400,
      backgroundColor: '#fbfbfd',
      minHeight: '100vh'
    }}>
      {/* Header with glassmorphism effect */}
      <header style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: scrolled ? 'rgba(251, 251, 253, 0.72)' : 'rgba(251, 251, 253, 0.9)',
        backdropFilter: 'blur(20px)',
        transition: 'all 0.3s ease',
        borderBottom: scrolled ? '1px solid rgba(0, 0, 0, 0.1)' : 'none'
      }}>
        <nav style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '60px'
        }}>
          <img 
            src="/assets/easypropertyinvestorimages/Logo.e0298b07.png" 
            alt="Easy Property Investor" 
            style={{ 
              height: '32px',
              filter: 'brightness(1.1) contrast(1.1)'
            }} 
          />
          
          <img 
            src="/assets/easypropertyinvestorimages/ssllogo.png" 
            alt="SSL Secured" 
            style={{ 
              height: '32px',
              opacity: 0.8
            }} 
          />
        </nav>
        
        {/* Rating bar with modern styling */}
        <div style={{ 
          width: '100%', 
          height: isMobile ? '40px' : '36px', 
          background: 'linear-gradient(135deg, #007AFF 0%, #0051D5 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: isMobile ? '13px' : '15px',
          fontWeight: '600',
          letterSpacing: '0.5px',
          boxShadow: '0 2px 8px rgba(0, 122, 255, 0.15)'
        }}>
          <img 
            src="/assets/easypropertyinvestorimages/star.png" 
            alt="5 stars" 
            style={{ 
              height: isMobile ? '14px' : '16px',
              marginRight: isMobile ? '6px' : '8px',
              filter: 'brightness(1.2)'
            }} 
          />
          <span>Rating 5 Star Reviews By Our Customers</span>
        </div>
      </header>

      {/* Hero Section with modern gradient */}
      <section style={{
        paddingTop: '120px',
        paddingBottom: isMobile ? '60px' : '80px',
        background: 'linear-gradient(180deg, #fbfbfd 0%, #f5f5f7 100%)',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Animated background elements */}
        <div style={{
          position: 'absolute',
          top: '10%',
          right: '-5%',
          width: '300px',
          height: '300px',
          background: 'radial-gradient(circle, rgba(0, 122, 255, 0.1) 0%, transparent 70%)',
          borderRadius: '50%',
          filter: 'blur(40px)',
          animation: 'float 6s ease-in-out infinite'
        }}></div>
        <div style={{
          position: 'absolute',
          bottom: '10%',
          left: '-5%',
          width: '250px',
          height: '250px',
          background: 'radial-gradient(circle, rgba(52, 199, 89, 0.1) 0%, transparent 70%)',
          borderRadius: '50%',
          filter: 'blur(40px)',
          animation: 'float 8s ease-in-out infinite reverse'
        }}></div>
        
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 20px',
          textAlign: 'center',
          position: 'relative',
          zIndex: 1
        }}>
          <h1 style={{ 
            color: '#007AFF',
            fontSize: isMobile ? '36px' : '56px',
            fontWeight: '700',
            letterSpacing: '-0.02em',
            margin: 0,
            animation: 'fadeInUp 0.8s ease'
          }}>
            REVEALED
          </h1>
          <p style={{
            color: '#1d1d1f',
            fontSize: isMobile ? '28px' : '48px',
            fontWeight: '600',
            margin: '12px 0',
            lineHeight: isMobile ? '1.1' : '1.2',
            letterSpacing: '-0.01em',
            animation: 'fadeInUp 0.8s ease 0.1s backwards'
          }}>
            The Secret Strategy The Wealthy Are Already Using<br/>
            To Buy Property In 2025
          </p>
          <p style={{
            color: '#1d1d1f',
            fontSize: isMobile ? '22px' : '32px',
            fontWeight: '500',
            margin: isMobile ? '20px 0' : '24px 0',
            animation: 'fadeInUp 0.8s ease 0.2s backwards'
          }}>
            Claim Your Free Hotspot Property Report
          </p>
          
          {/* Feature badges with glassmorphism */}
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: isMobile ? '12px' : '20px',
            margin: isMobile ? '24px 0' : '32px 0',
            animation: 'fadeInUp 0.8s ease 0.3s backwards'
          }}>
            {['Hotspots Revealed', 'Maximise Government Incentives', 'Redirect Tax Into Your Home Loan'].map((text, index) => (
              <div key={index} style={{
                display: 'flex',
                alignItems: 'center',
                padding: '8px 16px',
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                backdropFilter: 'blur(10px)',
                borderRadius: '20px',
                border: '1px solid rgba(0, 0, 0, 0.04)',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)'
              }}>
                <img src="/assets/easypropertyinvestorimages/green_tick.png" alt="✓" style={{ height: '16px', marginRight: '8px' }} />
                <span style={{ fontSize: isMobile ? '14px' : '16px', fontWeight: '500' }}>{text}</span>
              </div>
            ))}
          </div>
          
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: isMobile ? '12px' : '20px',
            marginBottom: '32px',
            animation: 'fadeInUp 0.8s ease 0.4s backwards'
          }}>
            {['Takes less than 60 seconds', 'No Cost, Obligation Free'].map((text, index) => (
              <div key={index} style={{
                display: 'flex',
                alignItems: 'center',
                padding: '8px 16px',
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                backdropFilter: 'blur(10px)',
                borderRadius: '20px',
                border: '1px solid rgba(0, 0, 0, 0.04)',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)'
              }}>
                <img src="/assets/easypropertyinvestorimages/green_tick.png" alt="✓" style={{ height: '16px', marginRight: '8px' }} />
                <span style={{ fontSize: isMobile ? '14px' : '16px', fontWeight: '500' }}>{text}</span>
              </div>
            ))}
          </div>
          
          {/* Credibility badges with modern card design */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(5, 1fr)',
            gap: isMobile ? '12px' : '16px',
            maxWidth: isMobile ? '100%' : '900px',
            margin: '32px auto',
            animation: 'fadeInUp 0.8s ease 0.5s backwards'
          }}>
            {[
              { emoji: '🏆', text: '50+ Years Experience' },
              { emoji: '💰', text: '$120k Avg Growth/Year' },
              { emoji: '⭐', text: '5-Star Reviews' },
              { emoji: '📈', text: 'Data-Driven Strategy' },
              { emoji: '🤝', text: 'ASX 50 Partnerships' }
            ].map((item, index) => (
              <div key={index} style={{
                padding: isMobile ? '12px' : '16px',
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                backdropFilter: 'blur(10px)',
                borderRadius: '16px',
                border: '1px solid rgba(0, 0, 0, 0.04)',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.04)',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                gridColumn: isMobile && index === 4 ? 'span 2' : 'span 1'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 0, 0, 0.08)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.04)';
              }}>
                <div style={{ fontSize: '28px', marginBottom: '8px' }}>{item.emoji}</div>
                <div style={{ fontSize: isMobile ? '12px' : '13px', fontWeight: '600', color: '#1d1d1f' }}>{item.text}</div>
              </div>
            ))}
          </div>
          
          {/* Progress bar with modern styling */}
          <div style={{
            maxWidth: '600px',
            margin: '40px auto 0',
            animation: 'fadeInUp 0.8s ease 0.6s backwards'
          }}>
            <div style={{
              textAlign: 'center',
              marginBottom: '12px',
              fontSize: '14px',
              color: '#86868b',
              fontWeight: '500'
            }}>
              {formStep === 0 ? 'Ready to start?' :
               `Step ${formStep} of 7 - ${Math.round((formStep / 7) * 100)}% Complete`}
            </div>
            <div style={{
              width: '100%',
              height: '8px',
              backgroundColor: 'rgba(0, 0, 0, 0.08)',
              borderRadius: '4px',
              overflow: 'hidden',
              position: 'relative'
            }}>
              <div style={{
                width: `${Math.max(5, (formStep / 7) * 100)}%`,
                height: '100%',
                background: 'linear-gradient(90deg, #007AFF 0%, #0051D5 100%)',
                borderRadius: '4px',
                transition: 'width 0.5s ease',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  backgroundImage: 'linear-gradient(to right, transparent, rgba(255,255,255,0.3), transparent)',
                  animation: 'shimmer 2s infinite',
                  width: '50%'
                }}></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Form Section with glassmorphism card */}
      <section style={{
        padding: isMobile ? '0 16px 60px' : '0 20px 80px',
        marginTop: '-40px',
        position: 'relative',
        zIndex: 2
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(20px)',
          borderRadius: '24px',
          padding: isMobile ? '32px 20px' : '48px',
          boxShadow: '0 12px 40px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(0, 0, 0, 0.04)',
          animation: 'fadeInUp 0.8s ease 0.7s backwards'
        }}>
          {formStep === 0 && (
            <>
              <h2 style={{
                textAlign: 'center',
                fontSize: isMobile ? '28px' : '36px',
                fontWeight: '600',
                color: '#1d1d1f',
                marginBottom: '32px',
                letterSpacing: '-0.01em'
              }}>
                Let's Get Started!<br/>
                What best describes your living situation?
              </h2>
              
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                gap: '16px'
              }}>
                {['Own Home', 'Mortgage / Paying off home', 'Renting but own an investment property', 'Renting'].map((option) => (
                  <button 
                    key={option}
                    onClick={() => {
                      const newData = { ...formData, livingSituation: option };
                      setFormData(newData);
                      localStorage.setItem('livingSituation', option);
                      if (option === 'Own Home' || option === 'Mortgage / Paying off home' || option === 'Renting but own an investment property') {
                        setFormStep(1);
                      } else {
                        setFormStep(2);
                      }
                    }}
                    style={{
                      padding: '20px',
                      fontSize: '16px',
                      fontWeight: '500',
                      color: '#1d1d1f',
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      border: '2px solid rgba(0, 122, 255, 0.2)',
                      borderRadius: '12px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      backdropFilter: 'blur(10px)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#007AFF';
                      e.currentTarget.style.color = '#fff';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 122, 255, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
                      e.currentTarget.style.color = '#1d1d1f';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}>
                    {option}
                  </button>
                ))}
              </div>
            </>
          )}
          
          {formStep === 1 && (
            <>
              <h2 style={{
                textAlign: 'center',
                fontSize: isMobile ? '28px' : '36px',
                fontWeight: '600',
                color: '#1d1d1f',
                marginBottom: '32px',
                letterSpacing: '-0.01em'
              }}>
                Have you owned your home for more than 3 years?
              </h2>
              
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                gap: '16px',
                maxWidth: '400px',
                margin: '0 auto'
              }}>
                {['Yes', 'No'].map((option) => (
                  <button 
                    key={option}
                    onClick={() => {
                      const isOwned = option === 'Yes';
                      localStorage.setItem('ownedYourHome', isOwned.toString());
                      setFormStep(2);
                    }}
                    style={{
                      padding: '20px',
                      fontSize: '16px',
                      fontWeight: '500',
                      color: '#1d1d1f',
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      border: '2px solid rgba(0, 122, 255, 0.2)',
                      borderRadius: '12px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      backdropFilter: 'blur(10px)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#007AFF';
                      e.currentTarget.style.color = '#fff';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 122, 255, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
                      e.currentTarget.style.color = '#1d1d1f';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}>
                    {option}
                  </button>
                ))}
              </div>
            </>
          )}
          
          {formStep === 2 && (
            <>
              <h2 style={{
                textAlign: 'center',
                fontSize: isMobile ? '26px' : '36px',
                fontWeight: '600',
                color: '#1d1d1f',
                marginBottom: '32px',
                letterSpacing: '-0.01em',
                lineHeight: '1.2'
              }}>
                Tax Incentives are State-Based<br/>
                Please Enter Your Postcode
              </h2>
              
              <div style={{
                maxWidth: '400px',
                margin: '0 auto'
              }}>
                <input
                  type="text"
                  placeholder="Enter your postcode"
                  value={formData.postcodeOptions}
                  onChange={(e) => setFormData({...formData, postcodeOptions: e.target.value})}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && formData.postcodeOptions.trim() !== '') {
                      localStorage.setItem('postcodeOptions', formData.postcodeOptions);
                      setFormStep(3);
                    }
                  }}
                  style={{
                    width: '100%',
                    padding: '16px',
                    fontSize: '17px',
                    marginBottom: '20px',
                    border: '2px solid rgba(0, 122, 255, 0.2)',
                    borderRadius: '12px',
                    textAlign: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(10px)',
                    transition: 'all 0.3s ease',
                    outline: 'none'
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = '#007AFF';
                    e.currentTarget.style.boxShadow = '0 0 0 3px rgba(0, 122, 255, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(0, 122, 255, 0.2)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                />
                <button
                  onClick={() => {
                    if (formData.postcodeOptions.trim() !== '') {
                      localStorage.setItem('postcodeOptions', formData.postcodeOptions);
                      setFormStep(3);
                    }
                  }}
                  style={{
                    width: '100%',
                    padding: '18px',
                    fontSize: '17px',
                    fontWeight: '600',
                    color: '#fff',
                    background: 'linear-gradient(135deg, #007AFF 0%, #0051D5 100%)',
                    border: 'none',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 16px rgba(0, 122, 255, 0.2)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 122, 255, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 122, 255, 0.2)';
                  }}
                >
                  Continue
                </button>
              </div>
            </>
          )}
          
          {formStep === 3 && (
            <>
              <h2 style={{
                textAlign: 'center',
                fontSize: isMobile ? '26px' : '36px',
                fontWeight: '600',
                color: '#1d1d1f',
                marginBottom: '12px',
                letterSpacing: '-0.01em'
              }}>
                What is your combined household income?
              </h2>
              <p style={{
                textAlign: 'center',
                fontSize: '16px',
                color: '#86868b',
                marginBottom: '32px'
              }}>
                You and partner (if applicable)
              </p>
              
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                gap: '16px'
              }}>
                {['$0 - $80,000', '$80,000 - $120,000', '$120,000 - $150,000', '$150,000 - $180,000', '$180,000 - $220,000', '$220,000 +'].map((option) => (
                  <button 
                    key={option}
                    onClick={() => {
                      const newData = { ...formData, householdIncome: option };
                      setFormData(newData);
                      localStorage.setItem('householdIncome', option);
                      setFormStep(4);
                    }}
                    style={{
                      padding: '20px',
                      fontSize: '16px',
                      fontWeight: '500',
                      color: '#1d1d1f',
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      border: '2px solid rgba(0, 122, 255, 0.2)',
                      borderRadius: '12px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      backdropFilter: 'blur(10px)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#007AFF';
                      e.currentTarget.style.color = '#fff';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 122, 255, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
                      e.currentTarget.style.color = '#1d1d1f';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}>
                    {option}
                  </button>
                ))}
              </div>
            </>
          )}
          
          {formStep === 4 && (
            <>
              <h2 style={{
                textAlign: 'center',
                fontSize: isMobile ? '26px' : '36px',
                fontWeight: '600',
                color: '#1d1d1f',
                marginBottom: '12px',
                letterSpacing: '-0.01em'
              }}>
                What is your combined household super balance?
              </h2>
              <p style={{
                textAlign: 'center',
                fontSize: '16px',
                color: '#86868b',
                marginBottom: '32px'
              }}>
                You and partner (if applicable)
              </p>
              
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                gap: '16px'
              }}>
                {['$0 - $100,000', '$100,000 - $200,000', '$200,000 - $300,000', '$300,000 - $400,000', '$400,000 - $500,000', '$500,000 +'].map((option) => (
                  <button 
                    key={option}
                    onClick={() => {
                      const newData = { ...formData, superBalance: option };
                      setFormData(newData);
                      localStorage.setItem('superBalance', option);
                      setFormStep(5);
                    }}
                    style={{
                      padding: '20px',
                      fontSize: '16px',
                      fontWeight: '500',
                      color: '#1d1d1f',
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      border: '2px solid rgba(0, 122, 255, 0.2)',
                      borderRadius: '12px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      backdropFilter: 'blur(10px)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#007AFF';
                      e.currentTarget.style.color = '#fff';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 122, 255, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
                      e.currentTarget.style.color = '#1d1d1f';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}>
                    {option}
                  </button>
                ))}
              </div>
            </>
          )}
          
          {formStep === 5 && (() => {
            setFormStep(6);
            return null;
          })()}
          
          {formStep === 6 && (
            <>
              <h2 style={{
                textAlign: 'center',
                fontSize: isMobile ? '26px' : '36px',
                fontWeight: '600',
                color: '#1d1d1f',
                marginBottom: '12px',
                letterSpacing: '-0.01em'
              }}>
                Please Enter Your Age
              </h2>
              <p style={{
                textAlign: 'center',
                fontSize: '16px',
                color: '#86868b',
                marginBottom: '32px',
                fontWeight: '500'
              }}>
                AGE
              </p>
              
              <div style={{
                maxWidth: '400px',
                margin: '0 auto'
              }}>
                <input
                  type="text"
                  placeholder="Enter your age"
                  value={formData.yourAge}
                  onChange={(e) => setFormData({...formData, yourAge: e.target.value})}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && formData.yourAge.trim() !== '') {
                      localStorage.setItem('yourAge', formData.yourAge);
                      setFormStep(7);
                    }
                  }}
                  style={{
                    width: '100%',
                    padding: '16px',
                    fontSize: '17px',
                    marginBottom: '20px',
                    border: '2px solid rgba(0, 122, 255, 0.2)',
                    borderRadius: '12px',
                    textAlign: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(10px)',
                    transition: 'all 0.3s ease',
                    outline: 'none'
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = '#007AFF';
                    e.currentTarget.style.boxShadow = '0 0 0 3px rgba(0, 122, 255, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(0, 122, 255, 0.2)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                />
                <button
                  onClick={() => {
                    if (formData.yourAge.trim() !== '') {
                      localStorage.setItem('yourAge', formData.yourAge);
                      setFormStep(7);
                    }
                  }}
                  style={{
                    width: '100%',
                    padding: '18px',
                    fontSize: '17px',
                    fontWeight: '600',
                    color: '#fff',
                    background: 'linear-gradient(135deg, #007AFF 0%, #0051D5 100%)',
                    border: 'none',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 16px rgba(0, 122, 255, 0.2)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 122, 255, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 122, 255, 0.2)';
                  }}
                >
                  Continue
                </button>
              </div>
            </>
          )}
          
          {formStep === 7 && (
            <>
              <h2 style={{
                textAlign: 'center',
                fontSize: isMobile ? '26px' : '36px',
                fontWeight: '600',
                color: '#1d1d1f',
                marginBottom: '32px',
                letterSpacing: '-0.01em'
              }}>
                What best describes your main goal right now?
              </h2>
              
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
                gap: '16px'
              }}>
                {['Build a property portfolio', 'Generate passive income', 'Find hotspot locations', 'Pay less tax', 'Pay off home quicker', 'All of the above'].map((option) => (
                  <button 
                    key={option}
                    onClick={() => {
                      const newData = { ...formData, bestDescribes: option };
                      setFormData(newData);
                      localStorage.setItem('bestDescribes', option);
                      setFormStep(8);
                    }}
                    style={{
                      padding: '20px',
                      fontSize: '16px',
                      fontWeight: '500',
                      color: '#1d1d1f',
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      border: '2px solid rgba(0, 122, 255, 0.2)',
                      borderRadius: '12px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      backdropFilter: 'blur(10px)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#007AFF';
                      e.currentTarget.style.color = '#fff';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 122, 255, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
                      e.currentTarget.style.color = '#1d1d1f';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}>
                    {option}
                  </button>
                ))}
              </div>
            </>
          )}
          
          {formStep === 8 && (
            <ProcessingScreen 
              isMobile={isMobile} 
              onComplete={() => {
                setFormStep(0);
              }}
            />
          )}
          
          {/* Trust indicator */}
          {formStep !== 8 && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '32px',
              gap: '12px',
              opacity: 0.8
            }}>
              <span style={{ fontSize: '14px', color: '#86868b' }}>🔒 Your information is secure and protected</span>
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        backgroundColor: '#f5f5f7',
        borderTop: '1px solid rgba(0, 0, 0, 0.08)',
        padding: '40px 20px',
        marginTop: '80px'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          textAlign: 'center'
        }}>
          <div style={{
            display: 'flex',
            gap: '24px',
            justifyContent: 'center',
            marginBottom: '24px',
            flexWrap: 'wrap'
          }}>
            <a href="/privacy-policy" style={{
              color: '#86868b',
              fontSize: '14px',
              textDecoration: 'none',
              transition: 'color 0.3s ease'
            }}>Privacy Policy</a>
            <a href="/terms-and-conditions" style={{
              color: '#86868b',
              fontSize: '14px',
              textDecoration: 'none',
              transition: 'color 0.3s ease'
            }}>Terms and Conditions</a>
            <a href="/cookie-policy" style={{
              color: '#86868b',
              fontSize: '14px',
              textDecoration: 'none',
              transition: 'color 0.3s ease'
            }}>Cookie Policy</a>
          </div>
          
          <p style={{
            color: '#86868b',
            fontSize: '12px',
            margin: '16px 0'
          }}>
            © 2025 Easy Property Investor. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default EasyPropertyInvestorVariation1;